import { timeFormat } from '@/utils/date';
const filters = {
	/**
	 * 表格中，如果返回数据为空则显示"--"
	 */
	filterEmpty(val) {
		if (!val) {
			return '--';
		}
		return val;
	},
	/**
	 * 加百分号
	 */
	filterPercent(val) {
		return val + '%';
	},
	/**
	 * 时间  yyyy-MM-dd HH:mm:ss
	 */
	filterDateTime(val) {
		return timeFormat(val + '000', 'yyyy-MM-dd hh:mm:ss');
	}
};
export default filters;
